import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import ConfirmationModal from '@grnhse/seedling/lib/birch/components/modals/confirmation_modal';
import {
  PrimaryButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.document_viewer_modal');

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  hostname: string;
};

const ExternalLinkConfirmationModal = ({
  isOpen,
  onDismiss,
  onConfirm,
  hostname,
}: Props) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <GlobalStyle />
      <ConfirmationModal
        isOpen
        ariaLabel={t('external_link_warning.title')}
        onDismiss={onDismiss}
        data-provides="external-link-confirmation-modal"
      >
        <ConfirmationModal.Header>
          <CenteredText>{t('external_link_warning.title')}</CenteredText>
        </ConfirmationModal.Header>
        <ConfirmationModal.Body>
          <CenteredText>
            <Body
              dangerouslySetInnerHTML={{
                __html: t('external_link_warning.body_html', { hostname }),
              }}
            />
          </CenteredText>
        </ConfirmationModal.Body>
        <ConfirmationModal.Footer>
          <SecondaryButton onClick={onDismiss}>
            {t('external_link_warning.cancel')}
          </SecondaryButton>
          <PrimaryButton onClick={onConfirm}>
            {t('external_link_warning.confirm')}
          </PrimaryButton>
        </ConfirmationModal.Footer>
      </ConfirmationModal>
    </>
  );
};

const CenteredText = styled.div`
  text-align: center;
`;

const GlobalStyle = createGlobalStyle`
  [data-provides='external-link-confirmation-modal'] [data-provides='stack'] {
    justify-content: center !important;
  }
`;

export default ExternalLinkConfirmationModal;
